<micro-lookup domain="auth" obj="companies" url="/companies" [key]="companyId" [link]="link"></micro-lookup>
